import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//import { useRazorpay } from "./razorpayservice";
import "./tokenlyglobal.css";
import "./alert-styles.css";

const TokenBook = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const {
    doctorId,
    shift = 0,
    shift_time,
    doctorName,
    clinicName,
  } = state;

  const [mobile, setMobile] = useState("");
  const [printerType, setPrinterType] = useState("blu");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  //const { openPayment, handleSuccess } = useRazorpay();

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!doctorId || !shift_time) {
      setError("Missing doctor or time slot details.");
      return;
    }

    const authToken = getAuthToken();
    console.log("authToken", authToken);
    if (!authToken) {

      const redirectBackUrl = '/doctor/' + doctorId;
      console.log("redirectBackUrl--------", redirectBackUrl);
      document.cookie = `redirectBackUrl=${encodeURIComponent(redirectBackUrl)}; path=/`;

      setError("Please login first.");
      navigate("/login");
      return;
    }

  }, []);

  // Fetch logged-in user's phone number
  useEffect(() => {
    const storedUser = localStorage.getItem("tokenly_user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setMobile(parsed.phone || "");
      } catch {
        setMobile("");
      }
    }
  }, []);

  const getAuthToken = () => {
    return localStorage.getItem("tokenly_token") || "";
  };

  const showPaymentCancelledAlert = () => {
    const alertDiv = document.createElement('div');
    alertDiv.className = 'alert-override payment-cancelled';
    alertDiv.innerHTML = `
      <strong>Payment Cancelled</strong>
      Payment was cancelled by user. You can try again anytime.
    `;

    document.body.appendChild(alertDiv);

    setTimeout(() => {
      alertDiv.classList.add('fade-out');
      setTimeout(() => {
        if (alertDiv.parentNode) {
          alertDiv.remove();
        }
      }, 300);
    }, 4000);

    alertDiv.addEventListener('click', () => {
      alertDiv.classList.add('fade-out');
      setTimeout(() => {
        if (alertDiv.parentNode) {
          alertDiv.remove();
        }
      }, 300);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!doctorId || !shift_time) {
      setError("Missing doctor or time slot details.");
      return;
    }

    if (!mobile) {
      setError("No phone number found. Please login again.");
      navigate("/login");
      return;
    }

    const authToken = getAuthToken();
    console.log("authToken", authToken);
    if (!authToken) {
      setError("Please login first.");
      navigate("/login");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setMessage("");



      //payTokenPayment(authToken, doctorName, shift_time, "", mobile, doctorId, shift, printerType)

      /*

       {
        itemId: itemId,
        shift: shift,
        shift_time: shiftTime,
        action: action,
      }
      await openPayment(
        authToken, doctorName, shift_time, "", mobile, doctorId, shift, printerType,
        () => navigate("/token-receipt"),
        showPaymentCancelledAlert
      );
      */

    } catch (err) {
      setError(err.message || "Payment failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: "500px", marginTop: "100px" }}>
      <div className="card shadow border-0">
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h6 className="mb-0 fw-bold">
            {doctorName || "Doctor"} - {shift_time || "Select Time"}
          </h6>
          <button
            type="button"
            className="btn-close btn-close-white"
            aria-label="Close"
            onClick={() => navigate(-1)}
          />
        </div>

        <div className="card-body p-4">
          <div className="btn-group w-100 mb-4">
            <button className="btn btn-dark fw-bold active">
              Just Me
            </button>
            <button className="btn btn-outline-secondary" disabled>
              Group / Family
            </button>
          </div>

          <div className="bg-light border rounded-3 py-3 px-3 text-center mb-4">
            <div className="fw-bold">{doctorName || "Doctor Name"}</div>
            <div className="text-secondary small">{shift_time || "Time Slot"}</div>
            <div className="text-success fw-bold mt-2 small"> <i className="fa-solid fa-circle-check me-1"></i> ₹5 Payment Required</div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="form-label small fw-bold text-muted">
                CONTACT MOBILE NUMBER
              </label>
              <div className="form-control form-control-lg fs-6 bg-light d-flex align-items-center">
                <span className="text-dark fw-medium">{mobile || "No phone number found"}</span>
              </div>
              <small className="text-muted">Using your registered mobile number</small>
            </div>

            <button
              type="submit"
              className="btn btn-success w-100 py-2 fw-bold"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </>
              ) : (
                "Generate Token"
              )}
            </button>
          </form>

          {message && (
            <div className="alert alert-success mt-3 small mb-0">{message}</div>
          )}
          {error && (
            <div className="alert alert-danger mt-3 small mb-0">{error}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TokenBook;
